<template>
  <div class="desktop_margin">
    <v-overlay :value="set_overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div class="desktopView pt-10">
      <h5 class="header-text">{{ $t("dashboard.header") }}</h5>
    </div>
    <div
      class="background_color desktop_top"
      :style="
        $vuetify.breakpoint.height < 450 ? { 'padding-left': '20px' } : {}
      "
    >
      <div class="text_color title-text">
        {{ $t("dashboard.form_created") }}: {{ payload.length }}/5
      </div>
      <div class="subtitle sub-title">
        {{ $t("newUi.adminPanel.infoToolTip1") }}

        <!-- <span class="mobileview">{{ $t("newUi.adminPanel.info1s") }}</span> -->
      </div>
    </div>
    <div
      class="row container desktop-margin-top padding_view"
      :style="
        $vuetify.breakpoint.height < 450
          ? { 'padding-left': '20px', 'max-width': '600px' }
          : {}
      "
    >
      <!-- <div class="desktop_col_class"></div> -->
      <div
        class="col"
        v-if="payload.filter((o) => o.type == 'Ordering form').length == 0"
      >
        <div class="text_color">
          {{ $t("newUi.sideBarData.orderForm") }}
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="i_icon">i</span>
            </template>
            <span> {{ $t("newUi.adminPanel.infoToolTip4") }} </span>
          </v-tooltip>
        </div>
        <div class="form_name" style="height:50px">
          {{ $t("newUi.adminPanel.infoToolTip2") }}
        </div>
        <div
          class="grid-container"
          style="grid-template-columns: repeat(2, 0fr)"
        >
          <!-- <div class="" v-for="item in 2" :key="item">
            <div>
              <v-img
                style="background-color: #fff"
                alt="image"
                :src="require('@/assets/img/order_image' + item + '.jpg')"
                class="image_size"
              ></v-img>
              <div class="form_name">{{ order_info[item - 1] }}</div>
            </div>
          </div> -->
          <div>
            <v-img
              style="background-color: #fff"
              alt="image"
              :src="require('@/assets/img/order_image1.jpg')"
              class="image_size"
            ></v-img>
            <div class="form_name" style="height:40px; margin-top:10px">
              {{ $t("newUi.sideBarData.dbDesc1") }}
            </div>
          </div>
          <div>
            <v-img
              style="background-color: #fff"
              alt="image"
              :src="require('@/assets/img/order_image2.jpg')"
              class="image_size"
            ></v-img>
            <div class="form_name" style="height:40px; margin-top:10px">
              {{ $t("newUi.sideBarData.dbDesc2") }}
            </div>
          </div>
        </div>
        <v-btn
          color="#8AB26D"
          style="margin-top: 2%"
          class="dashboard_buttons cursor-pointer"
          @click="createForm('Ordering form')"
          >{{ $t("newUi.adminPanel.createButton") }}</v-btn
        >
      </div>

      <v-container
        v-if="payload.filter((o) => o.type == 'Ordering form').length != 0"
      >
        <div class="text_color order-form">
          {{ $t("newUi.sideBarData.orderForm") }}
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="i_icon">i</span>
            </template>
            <span> {{ $t("newUi.adminPanel.infoToolTip4") }} </span>
          </v-tooltip>
        </div>
        <!-- <div>Create Your order form by adding <span 
              v-bind="attrs"
                v-on="on" class="i_icon" >i</span>categories and products and receive orders with quantity</div> -->
        <div class="grid-container">
          <div
            class=""
            v-for="(item, index) in payload.filter(
              (o) => o.type == 'Ordering form'
            )"
            :key="index"
          >
            <div>
              <v-img
                v-if="item.image != undefined"
                alt="image"
                :src="item.image"
                class="image_size cursor-pointer"
                @click="viewForm(item.link.split('/')[3])"
              ></v-img>
              <v-img
                v-if="item.image == undefined"
                alt="image"
                src="https://firebasestorage.googleapis.com/v0/b/gupshup-gipforms.appspot.com/o/files%2Flogo.png?alt=media&token=56547b3f-f39c-48cf-840f-e4bc085422a5"
                class="image_size cursor-pointer"
                @click="viewForm(item.link.split('/')[3])"
              ></v-img>
              <div class="mobileview shopName">{{ item.shopname }}</div>
              <div class="desktopView pt-2">
                <div class="d-flex justify-space-between">
                  <div
                    class="justify-start text-truncate shopName"
                    style="width: 110px"
                  >
                    {{ item.shopname }}
                  </div>
                  <span style="width:70px">
                    <img
                      class="icon_color cursor-pointer"
                      src="../assets/ui/share.svg"
                      alt=""
                      @click="openShareDialog(item)"
                    />

                    <img
                      class="icon_color cursor-pointer"
                      src="../assets/ui/delete_green.svg"
                      alt=""
                      @click="deleteFormDesktop(item.link)"
                    />
                  </span>
                </div>
              </div>
              <div class="mobileview">
                <img
                  class="icon_color cursor-pointer"
                  src="../assets/ui/share.svg"
                  alt=""
                  @click="openShareDialog(item)"
                />
                <!-- <i class="bi bi-files icon_color cursor-pointer" style="background-color: transparent;" @click="doCopyOutside(item.link)"></i> -->
                <img
                  class="icon_color cursor-pointer"
                  src="../assets/ui/delete_green.svg"
                  alt=""
                  @click="deleteFormMobile(item.link)"
                />
              </div>
            </div>
          </div>
          <div v-if="payload.length < 5">
            <v-card
              flat
              @click="createForm('Ordering form')"
              tile
              class="text-center image_size align-vertical-center cursor-pointer"
              style="padding-top: 30%; background-color: #f8faf7"
            >
              <img
                class="cursor-pointer plus_icon"
                src="../assets/ui/plus_green.svg"
                alt=""
              />
              <div class="test-center text_color">
                {{ $t("newUi.sideBarData.createButton") }}
              </div>
            </v-card>
          </div>
        </div>
      </v-container>
      <div
        class="col"
        v-if="payload.filter((o) => o.type != 'Ordering form').length == 0"
      >
        <div class="text_color">
          {{ $t("newUi.sideBarData.catForm") }}
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="i_icon">i</span>
            </template>
            <span> {{ $t("newUi.adminPanel.infoToolTip5") }} </span>
          </v-tooltip>
        </div>
        <div class="form_name" style="height:50px">
          {{ $t("newUi.adminPanel.infoToolTip3") }}
        </div>
        <div
          class="grid-container"
          style="grid-template-columns: repeat(2, 0fr)"
        >
          <!-- <div class="" v-for="item in 2" :key="item">
            <div>
              <v-img
                alt="image"
                :src="require('@/assets/img/catalogue_image' + item + '.jpg')"
                class="image_size"
              ></v-img>
              <div class="form_name">{{ catalogue_info[item - 1] }}</div>
            </div>
          </div> -->
          <div>
            <v-img
              alt="image"
              :src="require('@/assets/img/catalogue_image1.jpg')"
              class="image_size"
            ></v-img>
            <div class="form_name" style="height:40px; margin-top:10px">
              {{ $t("newUi.sideBarData.dbDesc4") }}
            </div>
          </div>
          <div>
            <v-img
              alt="image"
              :src="require('@/assets/img/catalogue_image2.jpg')"
              class="image_size"
            ></v-img>
            <div class="form_name" style="height:40px; margin-top:10px">
              {{ $t("newUi.sideBarData.dbDesc3") }}
            </div>
          </div>
        </div>
        <v-btn
          color="#8AB26D"
          style="margin-top: 2%"
          class="dashboard_buttons cursor-pointer"
          @click="createForm('Catalogue')"
          >{{ $t("newUi.adminPanel.createButton") }}</v-btn
        >
      </div>
      <v-container
        v-if="payload.filter((o) => o.type != 'Ordering form').length != 0"
      >
        <div class="text_color order-form">
          {{ $t("newUi.sideBarData.catForm") }}
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="i_icon">i</span>
            </template>
            <span> {{ $t("newUi.adminPanel.infoToolTip5") }} </span>
          </v-tooltip>
        </div>
        <!-- <div>Create Your order form by adding categories and products and receive orders with quantity</div> -->
        <div class="grid-container">
          <div
            class=""
            v-for="(item, index) in payload.filter(
              (o) => o.type != 'Ordering form'
            )"
            :key="index"
          >
            <div>
              <v-img
                v-if="item.image != undefined"
                alt="image"
                :src="item.image"
                class="image_size cursor-pointer"
                @click="viewForm(item.link.split('/')[3])"
              ></v-img>
              <v-img
                v-if="item.image == undefined"
                alt="image"
                src="https://firebasestorage.googleapis.com/v0/b/gip-forms.appspot.com/o/files%2Flogo.png?alt=media&token=e64ac0c9-481e-4607-9062-507e43306ddd"
                class="image_size cursor-pointer"
                @click="viewForm(item.link.split('/')[3])"
              ></v-img>
              <div class="mobileview shopName">{{ item.shopname }}</div>
              <div class="desktopView pt-2">
                <div class="d-flex justify-space-between">
                  <div
                    class="justify-start text-truncate shopName"
                    style="width: 110px"
                  >
                    {{ item.shopname }}
                  </div>
                  <span style="width:70px">
                    <img
                      class="icon_color cursor-pointer"
                      src="../assets/ui/share.svg"
                      alt=""
                      @click="openShareDialog(item)"
                    />
                    <img
                      class="icon_color cursor-pointer"
                      src="../assets/ui/delete_green.svg"
                      alt=""
                      @click="deleteFormDesktop(item.link)"
                    />
                  </span>
                </div>
              </div>
              <div class="mobileview">
                <img
                  class="icon_color cursor-pointer"
                  src="../assets/ui/share.svg"
                  alt=""
                  @click="openShareDialog(item)"
                />

                <!-- <i class="bi bi-files icon_color cursor-pointer" style="background-color: transparent;" @click="doCopyOutside(item.link)"></i> -->
                <img
                  class="icon_color cursor-pointer"
                  src="../assets/ui/delete_green.svg"
                  alt=""
                  @click="deleteFormMobile(item.link)"
                />
              </div>
            </div>
          </div>
          <div v-if="payload.length < 5">
            <v-card
              flat
              @click="createForm('Catalogue')"
              tile
              class="text-center image_size align-vertical-center cursor-pointer"
              style="padding-top: 30%; background-color: #f8faf7"
            >
              <img
                class="cursor-pointer plus_icon"
                src="../assets/ui/plus_green.svg"
                alt=""
              />
              <div class="test-center text_color">
                {{ $t("newUi.sideBarData.createButton") }}
              </div>
            </v-card>
          </div>
        </div>
      </v-container>
      <div class="desktop_col_class"></div>
    </div>
    <v-bottom-sheet v-model="dialog">
      <v-sheet class="text-center bottom_modal" height="200px">
        <div class="pt-8 text_color">
          {{ $t("newUi.editForm.deleteForm") }}
        </div>
        <v-container>
          <div>{{ $t("newUi.deleteForm.confirmDelete") }}</div>
          <v-spacer style="padding: 10px"></v-spacer>
          <v-btn
            color="#8AB26D"
            class="button_padding cursor-pointer"
            @click="doCancelDelete"
            >{{ $t("common.cancelButton") }}</v-btn
          >
          <v-btn
            color="#8AB26D"
            class="button_padding cursor-pointer"
            @click="doDeleteFormMobile(link)"
            >{{ $t("common.deleteButton") }}</v-btn
          >
        </v-container>
      </v-sheet>
    </v-bottom-sheet>

    <template>
      <v-dialog v-model="dialogDesktop" height="50vh" width="500">
        <v-sheet class="text-center dialog_desktop_delete">
          <div class="pt-8 text_color">
            {{ $t("newUi.editForm.deleteForm") }}
          </div>
          <div class="cancel-delete">
            <span class="cursor-pointer" @click="doCancelDelete">x</span>
          </div>
          <v-container style="position: relative;top: -15px;">
            <div>{{ $t("newUi.deleteForm.confirmDelete") }}</div>
            <v-spacer style="padding: 10px"></v-spacer>
            <v-btn
              color="#8AB26D"
              class="button_padding cursor-pointer"
              @click="doCancelDelete"
              >{{ $t("common.cancelButton") }}</v-btn
            >
            <v-btn
              color="#8AB26D"
              class="button_padding cursor-pointer"
              @click="doDeleteFormMobile(link)"
              >{{ $t("common.deleteButton") }}</v-btn
            >
          </v-container>
        </v-sheet>
      </v-dialog>
    </template>

    <v-dialog v-model="share_dialog" content-class="crop-dialog">
      <v-container style="height: 100px; background-color: #fff">
        <div class="d-flex justify-space-between text_color">
          <div class="d-flex justyfy-start">
            {{ $t("newUi.addCategory.shareLink") }}
          </div>
          <div
            class="d-flex justify-end cursor-pointer"
            style="font-size: 14px"
          >
            <span class="cursor-pointer" @click="share_dialog = false">x</span>
          </div>
        </div>
        <div class="d-flex mt-3">
          <social-share
            :share_url="this.form_url"
            :shopname="shareInfo.shopname"
            :desc="shareInfo.desc"
          ></social-share>
          <div class="do_copy" @click="doCopy">
            <img
              class="do_copy_icon cursor-pointer"
              src="../assets/ui/copy.svg"
              alt=""
            />
          </div>
        </div>
        <div class="bkg-end1">
          <input id="clipcopyinput1" />
        </div>
      </v-container>
    </v-dialog>
  </div>
</template>

<script>
import i18n from "../i18n";
import router from "../router/router";
import { deleteFile, loadFile, setLocale } from "../services/firebase";
import { deleteMasterData } from "../services/firebase";
import store from "../store/store";
import { saveFile } from "../services/firebase";
import socialShare from "./socialShare.vue";
export default {
  components: { socialShare },
  name: "GsItemCard",
  props: ["payload"],
  mounted() {
    console.log("payload", this.$store.state.forms);
    setLocale();
  },
  methods: {
    open: function() {
      router.push(this.payload.link);
    },
    deleteForm: function() {
      this.dialog = true;
    },
    deleteFormMobile: function(payloadlink) {
      this.dialog = true;
      this.link = payloadlink;
    },
    deleteFormDesktop: function(payloadlink) {
      this.dialogDesktop = true;
      this.link = payloadlink;
    },
    doDeleteForm: function() {
      this.dialog = false;
      this.deleteFormFile(this.payload.link);
    },
    doDeleteFormMobile: function(link) {
      this.dialog = false;
      this.dialogDesktop = false;
      this.deleteFormFile(link);
    },
    doCancelDelete: function() {
      this.dialog = false;
      this.dialogDesktop = false;
    },
    deleteFormFile: function(formlink) {
      //controller.pause();
      var storedata = this.$store;
      this.$store.dispatch("setOverlay", true);
      this.set_overlay = true;
      var elethis = this;
      for (var i = 0; i < this.$store.state.forms.length; i++) {
        console.log("formlink", formlink, this.$store.state.forms[i].link);
        if (this.$store.state.forms[i].link === formlink) {
          this.$store.state.forms.splice(i, 1);
          deleteMasterData(function(err) {
            console.log(err);
            return 0;
          }, this.$store.state);
          //var pos = parseInt(formlink.split("/")[3]);
          var pos;
          if (formlink.split("/")[3]) {
            pos = parseInt(formlink.split("/")[3]);
          } else {
            pos = parseInt(formlink.split("/")[2]);
          }
          deleteFile(this.$store.state.profile.uid, pos, function() {
            storedata.dispatch("setOverlay", false);
            elethis.set_overlay = false;
          });
          break;
        }
      }
    },
    viewForm: function(pos) {
      router.push("/admin/viewform/" + pos);
    },
    createForm(type) {
      var createPos = this.getFreePos();
      if (createPos === -1) {
        alert(i18n.t("alertText.fiveForms"));
        return;
      }
      //this.selectType(createPos);

      var newlink = "/admin/editform/" + createPos;
      var newForm = {
        id: store.state.profile.uid,
        pos: createPos,
        categs: ["Ordering form", "Catalogue"],
        shopname: "",
        shopdesc: "",
        type: type,
        catalogue: [],
        phone: "",
        amount: 0,
        maxlength: 0,
      };

      saveFile(
        store.state.profile.uid,
        createPos,
        JSON.stringify(newForm),
        function() {
          //state.forms.push({"shopname": "", "type": + type, "link":"/admin/" + createPos});
          if (router.currentRoute.fullPath != newlink) {
            router.push("/admin/editform/" + createPos);
          }
        }
      );
    },
    getFreePos() {
      var isPresent = [];
      for (var ii = 0; ii < 5; ii++) isPresent[ii] = false;
      for (var i = 0; i < this.$store.state.forms.length; i++) {
        var formlink = this.$store.state.forms[i].link;
        //var ipos = parseInt(formlink.split("/")[3]);
        var ipos;
        if (formlink.split("/")[3]) {
          ipos = parseInt(formlink.split("/")[3]);
        } else {
          ipos = parseInt(formlink.split("/")[2]);
        }
        if (ipos >= 0 && ipos < 5) isPresent[ipos] = true;
      }
      for (var j = 0; j < 5; j++) if (!isPresent[j]) return j;
      return -1;
    },
    selectType(callback) {
      this.$store.dispatch("setCurCallback", callback);
      //router.push("/newform");
      //this.$store.state.newformroute.newformdialog = true;
      store.dispatch("setOverlay", false);
    },
    openShareDialog(item) {
      this.fetchData(item.link.split("/")[3]);
      this.shareInfo = item;
      this.shareInfo.desc = item.desc ? item.desc : item.shopdesc;
      this.create_link(this.$store.state);
      this.share_dialog = true;
    },
    doCopyOutside: function(formLink) {
      this.fetchData(formLink.split("/")[3]);
      this.create_link(this.$store.state);
      var text = this.form_url;
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$store.state.snackbartext = i18n.t("common.copy");
          this.$store.state.snackbar = true;
        })
        .catch((error) => {
          console.log(error);
        });
      /*var textField = document.createElement("textarea");
      textField.innerText = text;
      document.body.appendChild(textField);
      textField.select();
      textField.focus(); //SET FOCUS on the TEXTFIELD
      try {
        var successful = document.execCommand("copy");
        if (successful) {
          textField.remove();
          this.$store.state.snackbartext = i18n.t("common.copy");
          this.$store.state.snackbar = true;
        }
      } catch (err) {
        console.log(err);
      }*/
    },
    doCopy: function() {
      var text = this.form_url;
      if (navigator || navigator != undefined) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.$store.state.snackbartext = i18n.t("common.copy");
            this.$store.state.snackbar = true;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        var textField = document.createElement("textarea");
        textField.innerText = text;
        document.body.appendChild(textField);
        textField.select();
        textField.focus(); //SET FOCUS on the TEXTFIELD

        try {
          var successful = document.execCommand("copy");
          console.log(successful);
          if (successful) {
            textField.remove();
            this.$store.state.snackbartext = i18n.t("common.copy");
            this.$store.state.snackbar = true;
          }
        } catch (err) {
          console.log(err);
        }
      }
      // var textField = document.createElement("textarea");
      // textField.innerText = text;
      // document.body.appendChild(textField);
      // textField.select();
      // textField.focus();  //SET FOCUS on the TEXTFIELD

      // try {
      //   var successful = document.execCommand("copy");
      //   console.log(successful);
      //   if (successful) {
      //     textField.remove();
      //     this.$store.state.snackbartext = i18n.t("common.copy");
      //     this.$store.state.snackbar = true;
      //   }
      // } catch (err) {
      //   console.log(err);
      // }
    },
    create_link: function(stateData) {
      if (stateData) {
        var url = window.location.protocol + "//" + location.host;
        this.form_url =
          url +
          "/form/" +
          stateData.currentForm.id +
          "/" +
          stateData.currentFormPos +
          "?lang=" +
          this.$store.state.locale;
      } else {
        this.form_url = "";
      }
    },
    fetchData(pos) {
      this.$store.state.currentFormPos = pos;
      loadFile(
        this.$store.state.profile.uid,
        pos,
        this.$store.state,
        function() {
          // if (error) {
          //   //TODO skeleton data
          //   store.dispatch("setCurrentFormData", {
          //     id: store.state.profile.uid,
          //     pos: store.state.currentFormPos,
          //     categs: ["Ordering form", "Catalogue"],
          //     shopname: "",
          //     shopdesc: "",
          //     type: "Ordering form",
          //     catalogue: [],
          //     phone: "+919000000000",
          //   });
          //   store.dispatch("setOverlay", false);
          // } else {
          //   store.dispatch("setOverlay", false);
          // }
        }
      );
    },
  },
  data: function() {
    return {
      dialog: false,
      dialogDesktop: false,
      link: "",
      form_url: "",
      share_dialog: false,
      shareInfo: {},
      set_overlay: false,
      order_info: [
        i18n.t("newUi.sideBarData.dbDesc1"),
        i18n.t("newUi.sideBarData.dbDesc2"),
      ],
      catalogue_info: [
        i18n.t("newUi.sideBarData.dbDesc4"),
        i18n.t("newUi.sideBarData.dbDesc3"),
      ],
      // order_images: ["@/assets/home-image1-1.png",
      //                       "@/assets/home-image1-1.png"]
    };
  },
  computed: {
    bkgcolor: function() {
      // var pos = this.payload.link.split("/")[3];

      var pos;
      if (this.payload.link.split("/")[3]) {
        pos = parseInt(this.payload.link.split("/")[3]);
      } else {
        pos = parseInt(this.payload.link.split("/")[2]);
      }

      var p = parseInt(pos + "") % 5;
      if (p == 0) return "red";
      if (p == 1) return "blue";
      if (p == 2) return "green";
      if (p == 3) return "brown";
      return "black";
    },
    type: function() {
      if (this.payload.type == "Ordering form") {
        return i18n.t("common.typeOrderForm");
      } else {
        return i18n.t("common.typeCatelogue");
      }
    },
  },
};
</script>
<style lang="scss">
.text_color {
  color: #8ab26d;
  font-weight: bold;
}
.background_color {
  background: #f4f4f4 0% 0% no-repeat padding-box;
  padding: 20px;
  width: 100%;
}
.dashboard_buttons {
  background-color: #2d9222;
  letter-spacing: 0px;
  color: white !important;
  text-transform: none;
}
.bottom_modal {
  border-top-right-radius: 20px !important;
  border-top-left-radius: 20px !important;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
// .dialog_desktop_delete {
//   // width: 300px;
// }
.grid-container {
  display: grid;
  grid-gap: 10px;
}

.social_style {
  padding: 10px;
  margin: 2px;
  justify-content: center;
  text-align: center;
  border-radius: 50%;
}
// @media (min-width: 960px){
//   .v-dialog__content, .snackbar-wrapper{
//     width: calc(100% - -256px) !important;
//   }}
@media (min-width: 320px) and (max-width: 960px) {
  .background_color {
    background-color: #f8faf7;
    padding: 10px;
    margin-bottom: 10px;
    width: 100%;
  }
  .icon_color {
    color: #8ab26d;
    justify-content: center;
    font-size: 20px;
    width: 26px;
    height: 26px;
    background-color: #f8faf7;
    padding: 5px;
    margin: 3px;
    border-radius: 3px;
  }
  .whatsappText {
    text-align: left;
    font-size: 13px;
    letter-spacing: 0px;
    color: #7c7c7c;
    opacity: 1;
  }
  .shopName {
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    color: #666666;
    opacity: 1;
  }
  .order-form {
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #8ab26d;
    opacity: 1;
  }
  .sub-title {
    font-weight: normal;
    font-size: 12px;
    letter-spacing: 0px;
    color: #666666;
    opacity: 1;
  }
  .form_name {
    text-align: left;
    font-size: 12px;
    letter-spacing: 0px;
    color: #666666;
  }
  .plus_icon {
    font-weight: bold;
    color: #8ab26d;
    width: 30px !important;
    padding: 0px !important;
    margin: 0px !important;
    height: 30px !important;
  }
  .do_copy {
    color: #fff;
    width: 38px;
    padding: 10px;
    height: 38px;
    border-radius: 50%;
    background-color: #f35f09d6;
  }
  .do_copy_icon {
    width: 17px;
    height: 17px;
    margin: 1px;
  }
  .i_icon {
    border-radius: 50%;
    font-size: 12px;
    padding: 0px 5px;
    border: 0.5px solid #666666;
    cursor: pointer;
  }
  .image_size {
    height: 140px;
    width: 140px;
  }
  .grid-container {
    grid-template-columns: repeat(2, 0.2fr);
  }
}
@media (min-width: 960px) {
  .desktop_margin {
    padding: 0rem 4rem;
  }
  .desktop_col_class {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
    padding: 12px;
  }
  .grid-container {
    grid-template-columns: repeat(3, 0fr);
  }
  .image_size {
    height: 170px;
    width: 170px;
  }
  .header-text {
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #31333e;
    opacity: 1;
  }
  .form_name {
    text-align: left;
    font-size: 12px;
    letter-spacing: 0px;
    color: #666666;
  }
  .title-text {
    font-weight: bold;
    font-size: 14px;
    letter-spacing: 0px;
    color: #8ab26d;
    opacity: 1;
  }
  .plus_icon {
    font-weight: bold;
    color: #8ab26d;
    width: 30px;
    padding: 0px;
    margin: 0px;
    height: 30px;
  }
  .sub-title {
    font-weight: normal;
    font-size: 12px;
    letter-spacing: 0px;
    color: #666666;
    opacity: 1;
  }
  .shopName {
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #666666;
    opacity: 1;
  }
  .order-form {
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #8ab26d;
    opacity: 1;
  }
  .desktop-margin-top {
    margin-top: 5%;
  }
  .do_copy {
    color: #fff;
    width: 38px;
    padding: 10px;
    height: 38px;
    border-radius: 50%;
    background-color: #f35f09d6;
  }
  .do_copy_icon {
    width: 17px;
    height: 17px;
    margin: 1px;
  }
  .i_icon {
    border-radius: 50%;
    font-size: 12px;
    padding: 0px 5px;
    border: 0.5px solid #666666;
    cursor: pointer;
  }
  .icon_color {
    color: #8ab26d;
    justify-content: center;
    font-size: 20px;
    width: 26px;
    height: 26px;
    background-color: #f8faf7;
    padding: 5px;
    margin: 3px;
    border-radius: 3px;
  }
}
.cancel-delete {
  display: flex;
  justify-content: flex-end;
  position: relative;
  top: -3rem;
  right: 1rem;
  font-size: 17px;
  font-weight: bold;
  color: #89b26c;
}
</style>
